/* unplugin-vue-components disabled */import { render } from "./DetailAside.vue?vue&type=template&id=3e603a90&scoped=true"
import script from "./DetailAside.vue?vue&type=script&lang=js"
export * from "./DetailAside.vue?vue&type=script&lang=js"

import "./DetailAside.vue?vue&type=style&index=0&id=3e603a90&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e603a90"]])

export default __exports__